import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class InitForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: this.STATUS_INIT,
      error: this.ERROR_NONE
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUrlChange = this.handleUrlChange.bind(this);
  }
  static get STATUS_INIT() {return 'init';}
  static get STATUS_ERROR() {return 'error';}
  static get ERROR_NONE() {return null;}
  static get ERROR_EMPTY() {return 'empty';}
  static get ERROR_INVALID() {return 'invalid';}
  render() {
    let {T} = this.props;
    return (
        <div className="title-form-box">
            {this.props.position === 'bottom' && <T.text tag="h2" text={"initform.bottom.top"}/>}
            {this.props.position === 'right' && <h1><T.text  text={"initform.right.top"}/><sup>BETA</sup></h1>}
            {this.props.position === 'right' && <T.text tag="p" text={"initform.right.description-one"}/>}
            <form onSubmit={this.handleSubmit}>
                <input
                  ref="url"
                  type="text"
                  placeholder={T.translate('initform.input-placeholder')}
                  onChange={this.handleUrlChange}
                />
                <input
                  type="submit"
                  value={T.translate('initform.button-text')}
                />
                {this.state.status === InitForm.STATUS_ERROR && this.state.error === InitForm.ERROR_EMPTY && <span className="empty-field-error"><T.text text={"initform.empty-field-error"}/></span>}
                {this.state.status === InitForm.STATUS_ERROR && this.state.error === InitForm.ERROR_INVALID && <span className="invalid-url"><T.text text={"initform.invalid-url"}/></span>}
            </form>
            {
              this.props.position === 'right' &&
              <p className="description">
                <T.text text={"initform.right.description-two"}/>
                <br/><br/>
                <T.text text={"initform.right.description-three"}/>
              </p>
            }
        </div>
    );
  }
  handleUrlChange(event) {
    this.resetState();
  }
  handleSubmit(event) {
    this.resetState();
    const inputUrl = ReactDOM.findDOMNode(this.refs.url);
    if (inputUrl) {
      if (!inputUrl.value) {
        this.setState({
          status: InitForm.STATUS_ERROR,
          error: InitForm.ERROR_EMPTY
        });
      } else if (!this.isValidURL(inputUrl.value)) {
        this.setState({
          status: InitForm.STATUS_ERROR,
          error: InitForm.ERROR_INVALID
        });
      } else {
        this.props.appStartHandler && this.props.appStartHandler(inputUrl.value);
        inputUrl.value = '';
      }
    }
    event.preventDefault();
  }
  resetState() {
    this.setState({
      status: InitForm.STATUS_INIT,
      error: InitForm.ERROR_NONE
    })
  }
  isValidURL(url) {
    return /^(https?):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?$/i.test(url);
  }
}



// WEBPACK FOOTER //
// ./src/components/form/init.js